import { render, staticRenderFns } from "./ReligionPicker.vue?vue&type=template&id=1b5740cf&"
import script from "./ReligionPicker.vue?vue&type=script&lang=js&"
export * from "./ReligionPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports